module.exports = __webpack_public_path__ + "static/media/pinterest-share-icon.66f823ea.png";